import {FC, ReactNode} from "react";
import {createPortal} from "react-dom";
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {elevation} from "@pg-design/elevation";
import {borderRadius, calculateRemSize, display, onDesktop, p} from "@pg-design/helpers-css";
import {useIsMounted} from "@pg-mono/hooks";

import {CloseButton} from "./CloseButton";
import {FeedbackPopupHeader} from "./FeedbackPopupHeader";
import {FeedbackPopupTrigger, IFeedbackPopupTriggerProps} from "./FeedbackPopupTrigger";
import {PageOverlay} from "./PageOverlay";

interface IProps {
    isOpen: boolean;
    isTriggerPromptActive?: boolean;
    onOpen: () => void;
    onClose: () => void;
    isTriggerPromptVisible?: boolean;
    position: "left" | "right";
    offset?: {
        bottom?: number;
    };
    fixedWidth?: string;
    fixedHeight?: string;
    stickToContent?: boolean;
    showOverlayOnMobile?: boolean;
    zIndex?: number;
    hideCloseButton?: boolean;
    children?: ReactNode;
    triggerMobile?: IFeedbackPopupTriggerProps["mobile"];
    triggerDesktop?: IFeedbackPopupTriggerProps["desktop"];
}

const defaultZIndex = 1000;

type FeedbackPopupType = FC<IProps> & {
    Header: typeof FeedbackPopupHeader;
};

export const FeedbackPopup: FeedbackPopupType = (props) => {
    const isMounted = useIsMounted();
    const hideCloseButton = props.hideCloseButton || false;
    const zIndex = props.zIndex || defaultZIndex;
    const isTriggerPromptActive = props.isTriggerPromptActive || false;

    if (!isMounted) {
        return null;
    }

    return createPortal(
        <div>
            {props.isOpen ? (
                <>
                    <PageOverlayStyled zIndex={zIndex} showOverlayOnMobile={props.showOverlayOnMobile} />
                    <FeedbackPopupWrapper
                        zIndex={props.zIndex}
                        fixedWidth={props.fixedWidth}
                        position={props.position}
                        offset={props.offset}
                        fixedHeight={props.fixedHeight}
                    >
                        {hideCloseButton ? null : <CloseButton onClose={props.onClose} css={closeButtonStyle} />}
                        <ContentWrapper fixedWidth={props.fixedWidth}>{props.children}</ContentWrapper>
                    </FeedbackPopupWrapper>
                </>
            ) : (
                <FeedbackPopupTrigger
                    isPromptActive={isTriggerPromptActive}
                    zIndex={zIndex}
                    position={props.position}
                    onOpen={props.onOpen}
                    mobile={props.triggerMobile}
                    desktop={props.triggerDesktop}
                />
            )}
        </div>,
        window.document.body
    );
};

FeedbackPopup.Header = FeedbackPopupHeader;

const FeedbackPopupWrapper = styled.div<Pick<IProps, "fixedWidth" | "position" | "offset" | "zIndex" | "fixedHeight">>`
    position: fixed;
    bottom: calc(${({offset}) => offset?.bottom ?? 0}px + 1.2rem);
    z-index: ${({zIndex}) => zIndex ?? defaultZIndex};
    left: ${calculateRemSize(1.5)};
    right: ${calculateRemSize(1.5)};
    ${({fixedWidth}) => (fixedWidth ? `width: ${fixedWidth};` : "")};
    ${({fixedHeight}) => (fixedHeight ? `height: ${fixedHeight};` : "")};

    @media (min-width: ${({theme}) => theme.breakpoints.sm}) {
        ${({fixedWidth}) => (fixedWidth ? `width: ${fixedWidth};` : "min-width: 32rem;")};

        ${(props) =>
            props.position === "right"
                ? css`
                      left: unset;
                  `
                : css`
                      right: unset;
                  `};
    }

    @media (min-width: ${({theme}) => theme.breakpoints.md}) {
        bottom: calc(${({offset}) => offset?.bottom ?? 0}px + ${calculateRemSize(3)});

        ${(props) =>
            props.position === "right"
                ? css`
                      right: ${calculateRemSize(4)};
                  `
                : css`
                      left: ${calculateRemSize(4)};
                  `};
    }
`;

const PageOverlayStyled = styled(PageOverlay)<Pick<IProps, "showOverlayOnMobile">>`
    ${({showOverlayOnMobile}) => (showOverlayOnMobile ? "" : "display: none;")};

    ${onDesktop(display("none"))};
`;

const ContentWrapper = styled.div<Pick<IProps, "fixedWidth">>`
    height: 100%;
    width: 100%;
    overflow: auto;
    min-height: 10rem;
    max-height: 95vh;
    max-height: 95svh; // fix problem with small mobile screens, fallback to vh units if not available
    background: #fff;
    ${borderRadius(2)};
    ${elevation()};

    ${p(1, 2, 2)};
`;

const closeButtonStyle = css`
    position: absolute;
    top: -${calculateRemSize(1)};
    right: -${calculateRemSize(1)};
`;
import {FC, ReactNode} from "react";
import {createPortal} from "react-dom";
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {elevation} from "@pg-design/elevation";
import {borderRadius, calculateRemSize, display, onDesktop, p} from "@pg-design/helpers-css";
import {useIsMounted} from "@pg-mono/hooks";

import {CloseButton} from "./CloseButton";
import {FeedbackPopupHeader} from "./FeedbackPopupHeader";
import {FeedbackPopupTrigger, IFeedbackPopupTriggerProps} from "./FeedbackPopupTrigger";
import {PageOverlay} from "./PageOverlay";

interface IProps {
    isOpen: boolean;
    isTriggerPromptActive?: boolean;
    onOpen: () => void;
    onClose: () => void;
    isTriggerPromptVisible?: boolean;
    position: "left" | "right";
    offset?: {
        bottom?: number;
    };
    fixedWidth?: string;
    fixedHeight?: string;
    stickToContent?: boolean;
    showOverlayOnMobile?: boolean;
    zIndex?: number;
    hideCloseButton?: boolean;
    children?: ReactNode;
    triggerMobile?: IFeedbackPopupTriggerProps["mobile"];
    triggerDesktop?: IFeedbackPopupTriggerProps["desktop"];
}

const defaultZIndex = 1000;

type FeedbackPopupType = FC<IProps> & {
    Header: typeof FeedbackPopupHeader;
};

export const FeedbackPopup: FeedbackPopupType = (props) => {
    const isMounted = useIsMounted();
    const hideCloseButton = props.hideCloseButton || false;
    const zIndex = props.zIndex || defaultZIndex;
    const isTriggerPromptActive = props.isTriggerPromptActive || false;

    if (!isMounted) {
        return null;
    }

    return createPortal(
        <div>
            {props.isOpen ? (
                <>
                    <PageOverlayStyled zIndex={zIndex} showOverlayOnMobile={props.showOverlayOnMobile} />
                    <FeedbackPopupWrapper
                        zIndex={props.zIndex}
                        fixedWidth={props.fixedWidth}
                        position={props.position}
                        offset={props.offset}
                        fixedHeight={props.fixedHeight}
                    >
                        {hideCloseButton ? null : <CloseButton onClose={props.onClose} css={closeButtonStyle} />}
                        <ContentWrapper fixedWidth={props.fixedWidth}>{props.children}</ContentWrapper>
                    </FeedbackPopupWrapper>
                </>
            ) : (
                <FeedbackPopupTrigger
                    isPromptActive={isTriggerPromptActive}
                    zIndex={zIndex}
                    position={props.position}
                    onOpen={props.onOpen}
                    mobile={props.triggerMobile}
                    desktop={props.triggerDesktop}
                />
            )}
        </div>,
        window.document.body
    );
};

FeedbackPopup.Header = FeedbackPopupHeader;

const FeedbackPopupWrapper = styled.div<Pick<IProps, "fixedWidth" | "position" | "offset" | "zIndex" | "fixedHeight">>`
    position: fixed;
    bottom: calc(${({offset}) => offset?.bottom ?? 0}px + 1.2rem);
    z-index: ${({zIndex}) => zIndex ?? defaultZIndex};
    left: ${calculateRemSize(1.5)};
    right: ${calculateRemSize(1.5)};
    ${({fixedWidth}) => (fixedWidth ? `width: ${fixedWidth};` : "")};
    ${({fixedHeight}) => (fixedHeight ? `height: ${fixedHeight};` : "")};

    @media (min-width: ${({theme}) => theme.breakpoints.sm}) {
        ${({fixedWidth}) => (fixedWidth ? `width: ${fixedWidth};` : "min-width: 32rem;")};

        ${(props) =>
            props.position === "right"
                ? css`
                      left: unset;
                  `
                : css`
                      right: unset;
                  `};
    }

    @media (min-width: ${({theme}) => theme.breakpoints.md}) {
        bottom: calc(${({offset}) => offset?.bottom ?? 0}px + ${calculateRemSize(3)});

        ${(props) =>
            props.position === "right"
                ? css`
                      right: ${calculateRemSize(4)};
                  `
                : css`
                      left: ${calculateRemSize(4)};
                  `};
    }
`;

const PageOverlayStyled = styled(PageOverlay)<Pick<IProps, "showOverlayOnMobile">>`
    ${({showOverlayOnMobile}) => (showOverlayOnMobile ? "" : "display: none;")};

    ${onDesktop(display("none"))};
`;

const ContentWrapper = styled.div<Pick<IProps, "fixedWidth">>`
    height: 100%;
    width: 100%;
    overflow: auto;
    min-height: 10rem;
    max-height: 95vh;
    max-height: 95svh; // fix problem with small mobile screens, fallback to vh units if not available
    background: #fff;
    ${borderRadius(2)};
    ${elevation()};

    ${p(1, 2, 2)};
`;

const closeButtonStyle = css`
    position: absolute;
    top: -${calculateRemSize(1)};
    right: -${calculateRemSize(1)};
`;
